import * as React from 'react';
import { Checkbox, Link, Responsive, UIText3 } from '@cian/ui-kit';
import * as styles from './DisclaimerField.css';
import { NBSP } from '../../constants/text';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DisclaimerField = function DisclaimerField(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    marketingAgreementUrl = _ref.marketingAgreementUrl,
    personalDataAgreementUrl = _ref.personalDataAgreementUrl;
  var handleChange = React.useCallback(function (_event, value) {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    "data-testid": "disclaimer-field",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(UIText3, {
        color: "text-secondary-default",
        children: ["\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443, \u044F", NBSP, "\u0441\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430", NBSP, /*#__PURE__*/_jsx(Link, {
          fontSize: "XS",
          inline: true,
          href: personalDataAgreementUrl,
          children: "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
        }), ' ', "\u0432", NBSP, "\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441", NBSP, /*#__PURE__*/_jsx(Link, {
          fontSize: "XS",
          inline: true,
          href: privacyPolicyUrl,
          children: "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"
        })]
      })
    }), /*#__PURE__*/_jsx(Responsive, {
      desktop: true,
      tablet: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['agreement-checkbox'],
        children: [/*#__PURE__*/_jsx(Checkbox, {
          id: "cbw-user-agreement",
          checked: checked,
          disabled: disabled,
          onChange: handleChange,
          "data-testid": "user-agreement",
          dataTestId: "user-agreement"
        }), /*#__PURE__*/_jsx("label", {
          className: styles['label'],
          htmlFor: "cbw-user-agreement",
          children: /*#__PURE__*/_jsxs(UIText3, {
            color: "text-secondary-default",
            children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430", NBSP, /*#__PURE__*/_jsx(Link, {
              fontSize: "XS",
              inline: true,
              href: marketingAgreementUrl,
              children: "\u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438 \u0438 \u0437\u0432\u043E\u043D\u043A\u0438"
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Responsive, {
      phone: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['agreement-checkbox--mobile'],
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "cbw-user-agreement",
          children: /*#__PURE__*/_jsxs(UIText3, {
            color: "text-secondary-default",
            children: ["\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u044E\u0441\u044C \u043D\u0430", NBSP, /*#__PURE__*/_jsx(Link, {
              fontSize: "XS",
              inline: true,
              href: marketingAgreementUrl,
              children: "\u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438 \u0438 \u0437\u0432\u043E\u043D\u043A\u0438"
            })]
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          id: "cbw-user-agreement",
          checked: checked,
          disabled: disabled,
          onChange: handleChange,
          "data-testid": "user-agreement",
          dataTestId: "user-agreement"
        })]
      })
    })]
  });
};